import React from "react";

export default function ReviewnApproval(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">
        Oversight, Amendments, Review & Approval
      </h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700">
            CEO, Slum Soccer shall oversee the implementation of the policy, the
            organizing of trainings on the subject, following of policy
            guidelines and its monitoring and evaluation.
          </span>
        </div>
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700">
            Any amendment to this policy can be made only with the approval of CEO, Slum Soccer. 
          </span>
        </div>
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700">
            A self-audit of this policy would be conducted and the policy would be reviewed 
periodically but not later than two years from the date of the last review.  
          </span>
        </div>
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700">
            For any clarification or explanation in respect of this policy, please contact Ms.Shiba 
Marcus, Presiding Officer, ICC, SS at <a href="tel:+919637272665" className="text-yellow-500 hover:underline">+91 9637272665</a> Email ID: <a href="mailto:shiba.markas@slumsoccer.org" className="text-yellow-500 hover:underline">shiba.markas@slumsoccer.org</a>
          </span>
        </div>
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700">
            This Policy (Version 2), has been approved by the CEO of Slum Soccer Dr. Abhijeet Barse 
and is effective from October 1, 2024. 
          </span>
        </div>
      </div>
    </div>
  );
}
